import { SEARCH_ENGINE_USER } from '@/utils/const';

export default function getSearchEngineUser() {
    return SEARCH_ENGINE_USER;
}
